import { Network } from '@capacitor/network';
import { isNative } from '../platform';

/** Returns true if device currently has network connectivity. */
export async function isOnline(): Promise<boolean> {
  if (!isNative) return navigator.onLine;
  try {
    const status = await Network.getStatus();
    return status.connected;
  } catch {
    return navigator.onLine;
  }
}

/**
 * Subscribe to network status changes.
 * Returns a cleanup function to unsubscribe.
 */
export async function setupNetworkListener(
  callback: (connected: boolean) => void,
): Promise<() => void> {
  if (!isNative) {
    const onOnline  = () => callback(true);
    const onOffline = () => callback(false);
    window.addEventListener('online',  onOnline);
    window.addEventListener('offline', onOffline);
    return () => {
      window.removeEventListener('online',  onOnline);
      window.removeEventListener('offline', onOffline);
    };
  }
  const handle = await Network.addListener('networkStatusChange', status => {
    callback(status.connected);
  });
  return () => handle.remove();
}
